// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

// Used for I18n copy translations
import { LanternTenants, TenantId } from "../types";
import US_MO_TRANSLATIONS from "./us_mo_translations";
import US_PA_TRANSLATIONS from "./us_pa_translations";

export const US_MO = "US_MO";
export const US_PA = "US_PA";
export const US_DEMO = "US_DEMO";

export const LANTERN_TENANTS = [US_MO, US_PA] as const;
export const LANTERN_PATH = "/community/revocations";

export function isLanternTenantId(tenantId: TenantId): boolean {
  return LANTERN_TENANTS.includes(tenantId as LanternTenants);
}

export function isLanternPage(): boolean {
  return window.location.pathname?.startsWith(LANTERN_PATH);
}

export const TRANSLATIONS = {
  US_MO: US_MO_TRANSLATIONS,
  US_PA: US_PA_TRANSLATIONS,
};
